import { classNames } from "primereact/utils";
import styles from "./DefaultSliderField.module.scss";
import { Controller, useFormContext } from "react-hook-form";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { useAppContext } from "../../../../../AppContext";
import { AppTooltip } from "../../../tooltip/AppTooltip";
import { Slider } from "primereact/slider";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface IDefaultSliderField {
  className?: string;
  name: string;
  tooltip?: string;
  label?: string;
  required?: boolean;
  width?: string;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
  showValue?: boolean;
  valueSuffix?: string;
  showScale?: boolean;
  scaleLabels?: string[];
}

export const DefaultSliderField = ({
  className,
  name,
  tooltip,
  label,
  required = false,
  width,
  min,
  max,
  step = 1,
  disabled = false,
  showValue = true,
  valueSuffix = "",
  showScale = true,
  scaleLabels,
}: IDefaultSliderField) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }

  const defaultScaleLabels = scaleLabels || [
    `${min}${valueSuffix}`,
    `${Math.round((min + max) / 2)}${valueSuffix}`,
    `${max}${valueSuffix}`,
  ];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div
          style={{ width: width, maxWidth: width }}
          className={classNames(className, styles.root, {
            [styles.root_disabled]: disabled,
          })}
        >
          <RenderWhen condition={!!label}>
            <div
              className={classNames(styles.root_label, {
                [styles.root_label_error]: !!fieldState.error?.message,
              })}
            >
              <span>
                {label}
                {required ? "*" : ""}
              </span>
              <RenderWhen condition={showValue}>
                <span className={styles.root_label_value}>
                  {field.value}
                  {valueSuffix}
                </span>
              </RenderWhen>
              <AppTooltip content={tooltip} />
            </div>
          </RenderWhen>
          <div className={styles.root_slider_container}>
            <Slider
              value={field.value as number}
              onChange={(e) => field.onChange(e.value)}
              min={min}
              max={max}
              step={step}
              disabled={disabled}
              className={styles.root_slider}
            />
          </div>
          <RenderWhen condition={showScale}>
            <div className={styles.root_scale}>
              {defaultScaleLabels.map((scaleLabel, index) => (
                <span key={index}>{scaleLabel}</span>
              ))}
            </div>
          </RenderWhen>
        </div>
      )}
    />
  );
};
